import React from 'react';

import AggregateShellComponent from "core/gd-modules/common/aggregate/aggregate-shell";

export default function AggregateProgress(options, props) {

    const isValid = !_.isNil(props.value) && !_.isNaN(props.value);
    const value = isValid ? gd.utils.floorToDecimals(props.value, 0) : null;

    return (
        <AggregateShellComponent className="aggregate-progress" options={options} noData={!isValid} hint={value + "%"} {...props}>
            {isValid &&
            <div className="gd-select-progress">
                <div className="ui5-progress bar-50">
                    <div className="progress-bg">
                        {!!value && <div className="progress-line" style={{width:'{0}%'.f(value)}}/>}
                    </div>

                    {!_.isNil(value) && <div className="progress-label ui5-txt-less-important-small percentage">{value}%</div>}
                </div>
            </div>}

            {!isValid && <div className="aggregate-value aggregate-no-data">{gd.const.aggregate.label[props.aggregateFunction]}</div>}
        </AggregateShellComponent>
    );
}
